import { FormikErrors } from "formik";
import { useTranslation } from "react-i18next";
import {
  DataEntryAccidentStepSectionProps,
  FormikAccidentCircumstances,
  Optional,
  VehicleType,
} from "src/types";
import { useInputGroup } from "src/ui/widgets/input-group/input-group.hook";
import { useAccidentCircumstancesOptions } from "src/utils";

export const useDataEntryAccidentStepCircumstances = (
  props: DataEntryAccidentStepSectionProps,
) => {
  const { t } = useTranslation();
  const { imagesSource } = useInputGroup({ style: "checkbox" });
  const {
    formik,
    formikAccidentValues,
    formikAccidentErrors,
    formikAccidentTouched,
  } = props;
  const { setFieldValue } = formik;

  const { accidentCircumstancesOptions } = useAccidentCircumstancesOptions();

  const handleCircumstanceChange = (vehicleIndex: number, key: string) => {
    const currentValue =
      formikAccidentValues.vehicleAccidentCircumstances[vehicleIndex]
        ?.selectedCircumstance;

    let newValue: Optional<string> = key;

    if (currentValue === key) {
      newValue = undefined;
    }

    setFieldValue(
      `accidentData.vehicleAccidentCircumstances.${vehicleIndex}.selectedCircumstance`,
      newValue,
    );
  };
  const findVehicleIndex = (type: VehicleType) =>
    formikAccidentValues.vehicleAccidentCircumstances.findIndex(
      (v) => v.vehicleType === type,
    );

  const findVehicleErrorIfTouched = (index: number): string | undefined => {
    if (index < 0) return undefined;

    const errs = formikAccidentErrors?.vehicleAccidentCircumstances as
      | FormikErrors<FormikAccidentCircumstances>[]
      | undefined;
    const touchedFlags = formikAccidentTouched?.vehicleAccidentCircumstances;

    if (
      !errs ||
      !Array.isArray(errs) ||
      !touchedFlags ||
      !Array.isArray(touchedFlags)
    )
      return undefined;

    const err: FormikErrors<FormikAccidentCircumstances> = errs[index];
    const touched = touchedFlags[index];

    if (!err || !touched) return undefined;

    return err.selectedCircumstance;
  };

  const vehicleAIndex = findVehicleIndex(VehicleType.VEHICLE_A);
  const vehicleBIndex = findVehicleIndex(VehicleType.VEHICLE_B);

  const vehicleAError = findVehicleErrorIfTouched(vehicleAIndex);
  const vehicleBError = findVehicleErrorIfTouched(vehicleBIndex);

  return {
    imagesSource,
    accidentCircumstancesOptions,
    vehicleAIndex,
    vehicleBIndex,
    vehicleAError,
    vehicleBError,
    handleCircumstanceChange,
    t,
  };
};
